import { createStore } from 'vuex'
import member from "@/store/modules/member.js"
import event from "@/store/modules/event.js"
import participant from "@/store/modules/participant.js"
import persons from "@/store/modules/persons.js"
import memberTypeCorrection from "@/store/modules/member-type-correction.js"
import pkg from "@/../package.json"

export default createStore({
  state: {
    packageVersion: process.env.VUE_APP_VERSION || pkg.version || '0',
  },
  mutations: {
  },
  actions: {
  },
  getters: {
    appVersion: (state) => {
      return state.packageVersion
    }
  },
  modules: {
    member,
    event,
    participant,
    persons,
    memberTypeCorrection
  },
  strict: true
})
